
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.867.226L8.994 8.158 1.061.285l-.905.913L8.088 9.07.215 17.003l.913.906 7.873-7.933 7.932 7.874.906-.913-7.933-7.873 7.873-7.933z"}})])
          )
        }
      }
    